import { z } from 'zod';
// ------------------------------------------------------------ conta Asaas da clínica
export const gatewayStatusSchema = z.object({
    configured: z.boolean(),
    environment: z.enum(['sandbox', 'production']).nullable(),
    apiKeyLast4: z.string().nullable(),
    accountName: z.string().nullable(),
    webhook: z.boolean(),
    updatedAt: z.string().nullable(),
});
export const saveGatewaySchema = z.object({
    environment: z.enum(['sandbox', 'production']),
    apiKey: z.string().trim().min(20, 'Cole a chave de API completa').max(400),
});
// ------------------------------------------------------------ cobranças
export const CHARGE_METHODS = ['pix', 'boleto', 'credit_card'];
export const CHARGE_STATUSES = ['pending', 'partially_paid', 'paid', 'overdue', 'cancelled', 'refunded'];
export const createChargeSchema = z.object({
    method: z.enum(CHARGE_METHODS),
    /** cartão: número de parcelas (até o do orçamento); boleto: parcelas mensais */
    installments: z.number().int().min(1).max(24).default(1),
    dueDate: z.iso.date().optional(),
    notify: z.boolean().default(true),
});
export const chargeSchema = z.object({
    id: z.uuid(), patientId: z.uuid(), patientName: z.string(), quoteId: z.uuid().nullable(), quoteCode: z.string().nullable(),
    description: z.string(), method: z.enum(CHARGE_METHODS), installments: z.number().int(),
    amountCents: z.number().int(), paidCents: z.number().int(), dueDate: z.string(), status: z.enum(CHARGE_STATUSES),
    invoiceUrl: z.string().nullable(), pixPayload: z.string().nullable(), pixQrPng: z.string().nullable(),
    createdAt: z.string(), paidAt: z.string().nullable(), sandbox: z.boolean(),
    payments: z.array(z.object({ number: z.number().int(), valueCents: z.number().int(), status: z.string(), dueDate: z.string().nullable(), paidAt: z.string().nullable() })),
});
export const chargesSummarySchema = z.object({
    receivedMonthCents: z.number().int(), openCents: z.number().int(), overdueCents: z.number().int(),
});
export const METHOD_LABELS = { pix: 'Pix', boleto: 'Boleto', credit_card: 'Cartão de crédito' };
//# sourceMappingURL=payments.js.map